<script>
  import {Pie} from 'vue-chartjs'
  import _ from 'lodash'

  export default {
    name: "QcPieChart",
    extends: Pie,
    props: ['data'],
    computed: {
      labels() {
        return _.map(this.data, 'clasification')
      },
      dataset() {
        return _.map(this.data, 'net_kilograms')
      },
      colors() {
        return _.map(this.data, 'color')
      },
    },
    mounted() {
      this.renderChart({
          labels: this.labels,
          datasets: [
            {
              backgroundColor: this.colors,
              data: this.dataset
            }
          ]
        },
        {
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: 'percentage',
            precision: 1
          }
        })
    }
  }
</script>

<style scoped>

</style>
